import React from 'react';
import './AppTransition.css';

// Fades a page (or a settings tab) in when it mounts.
const AppTransition = ({ children }) => <div className="app-transition-wrapper">{children}</div>;

export default AppTransition;
